import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { StyledCircularProgress, TrackCircularProgress } from './style';

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <TrackCircularProgress variant="determinate" value={100} size={props.size} thickness={6} />
            <StyledCircularProgress variant="determinate" thickness={6} {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography variant="h6" component="div" sx={{ color: 'text.primary', fontWeight: 700 }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired
};

export default function CircularWithValueLabel({ value, maxValue }) {
    const percent = Number(((value / maxValue) * 100).toFixed(0));

    return <CircularProgressWithLabel value={percent} size={'10rem'} />;
}
